var _rect, _rect2, _rect3, _rect4, _rect5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoaderBracelet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 135,
    height: 60,
    viewBox: "0 0 50 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 5,
    height: 60,
    rx: 2,
    fill: "#9F9F9F"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeType: "CSS",
    attributeName: "height",
    values: "60;20;60;",
    begin: "0s",
    dur: "2s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeType: "CSS",
    attributeName: "y",
    begin: "0s",
    values: "0;20;0;",
    dur: "2s",
    repeatCount: "indefinite"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 0,
    width: 5,
    height: 60,
    rx: 2,
    fill: "#C1C1C1"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeType: "CSS",
    attributeName: "height",
    values: "60;20;60",
    begin: "0.4s",
    dur: "2s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeType: "CSS",
    attributeName: "y",
    values: "0;20;0",
    begin: "0.4s",
    dur: "2s",
    repeatCount: "indefinite"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 0,
    width: 5,
    height: 60,
    rx: 2,
    fill: "#FFCF4B"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeType: "CSS",
    attributeName: "height",
    values: "60;20;60",
    begin: "0.8s",
    dur: "2s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeType: "CSS",
    attributeName: "y",
    values: "0;20;0",
    begin: "0.8s",
    dur: "2s",
    repeatCount: "indefinite"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 0,
    width: 5,
    height: 60,
    rx: 2,
    fill: "#80B6C1"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeType: "CSS",
    attributeName: "height",
    values: "60;20;60",
    begin: "1.2s",
    dur: "2s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeType: "CSS",
    attributeName: "y",
    values: "0;20;0",
    begin: "1.2s",
    dur: "2s",
    repeatCount: "indefinite"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 0,
    width: 5,
    height: 60,
    rx: 2,
    fill: "#4F9BAA"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeType: "CSS",
    attributeName: "height",
    values: "60;20;60",
    begin: "1.6s",
    dur: "2s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeType: "CSS",
    attributeName: "y",
    values: "0;20;0",
    begin: "1.6s",
    dur: "2s",
    repeatCount: "indefinite"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderBracelet);
export default __webpack_public_path__ + "static/media/loader-bracelet.38a6863ec302e596861b3823f5abd34a.svg";
export { ForwardRef as ReactComponent };